import React from "react";
import styled from "styled-components";
import { variant as _variant } from "styled-system";
import { Card } from "../Card";
import { Title } from "../Title";

interface Props {
  title: string;
  variant: "chequered" | "solid";
}

const CardWrapper = styled(Card)<any>(
  _variant({
    scale: "chequeredCard",
    variants: {
      chequered: {
        bg: "greyLight",
      },
      solid: {
        bg: "white",
      },
    },
  }),
);

export const BaseChequeredCard: React.FC<Props> = ({
  title,
  variant,
  children,
}) => {
  return (
    <CardWrapper
      data-testid="ChequeredCard"
      variant={variant}
      flexDirection="column"
      width="100%"
      p={4}
    >
      <Title as="h3" m={0}>
        {title}
      </Title>
      {children}
    </CardWrapper>
  );
};
